//--------------------------------
// 產品細節
let detailSwiper = null,
	detailThumbsSwiper = null;

function buildDetailCarousel() {
	const swiperTarget = '#detail-carousel';
	var lazyLoadInstance = new LazyLoad();

	if ($(swiperTarget)) {
		detailThumbsSwiper = new Swiper('.product-detail .swiper-thumbs', {
			spaceBetween: 10,
			slidesPerView: 'auto',
			watchOverflow: true,
			breakpoints: {
				1440: {
					spaceBetween: 20,
					slidesPerView: 5,
				},
			},
			on: {
				init: function () {
					setWrapperStyles($(this)[0]);
				},
				resize: function () {
					// 數量不足時，置中
					setWrapperStyles($(this)[0]);
				},
			},
		});

		detailSwiper = new Swiper(swiperTarget, {
			slidesPerView: 1,
			spaceBetween: 10,
			watchOverflow: true,
			navigation: {
				nextEl: '.detail-swiper .swiper-button-next',
				prevEl: '.detail-swiper .swiper-button-prev',
			},
			pagination: {
				el: '.detail-swiper .swiper-pagination',
				clickable: true,
			},
			thumbs: {
				swiper: detailThumbsSwiper,
			},
		});
	}
}

window.addEventListener('load', buildDetailCarousel);

//--------------------------------
// 安裝說明
let installSwiper = null;

function buildInstallCarousel() {
	const swiperTarget = '#install-carousel';
	var lazyLoadInstance = new LazyLoad();

	if ($(swiperTarget)) {
		installSwiper = new Swiper(swiperTarget, {
			spaceBetween: 40,
			slidesPerView: 'auto',
			watchOverflow: true,
			navigation: {
				nextEl: '.install-swiper .swiper-button-next',
				prevEl: '.install-swiper .swiper-button-prev',
			},
			pagination: {
				el: '.product-install .swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				1200: {
					spaceBetween: 85,
					slidesPerView: 4,
				},
				640: {
					spaceBetween: 60,
					slidesPerView: 4,
				},
			},
			on: {
				init: function () {
					setWrapperStyles($(this)[0]);
				},
				breakpoint: function () {
					// 數量不足時，置中
					setWrapperStyles($(this)[0]);
				},
			},
		});
	}
}

window.addEventListener('load', buildInstallCarousel);

//--------------------------------

function setWrapperStyles(swiper) {
	var wrapperCenterClass = 'swiper-wrapper__center';
	var wrapperEl = swiper.wrapperEl;

	if (swiper.isLocked) {
		wrapperEl.classList.add(wrapperCenterClass);
	} else {
		wrapperEl.classList.remove(wrapperCenterClass);
	}
};

//--------------------------------
